<!--
  ~ Copyright (c) 1999 - 2020 Accorto, Inc. - All rights reserved.
  -->

<section class="slds-form slds-m-top_small" role="list">

  <div *ngIf="this.project"
       class="slds-form__row slds-m-top_small">
    <div class="slds-form__item" role="listitem">
      <div class="slds-form-element">
        <label for="pr-select-start-node">Select Start Node</label>
        <div class="slds-form-element__control">
          <div class="slds-select_container">
            <select (change)="onChangeStartNode($event)" class="slds-select"
                    id="pr-select-start-node">
              <option *ngFor="let n of nodeStartList" value="{{n.id}}">{{n.label}}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="slds-form__item" role="listitem">
      <acc-date-element (dateSelected)="onStartDate($event)" [theDate]="startDate"
                        label="Start Date"
                        theId="ps-startDate"></acc-date-element>
    </div>
  </div>

  <div class="slds-form__row slds-m-top_small">
    <div class="slds-form__item" role="listitem">
      <div class="slds-form-element">
        <div class="slds-form-element__control">
          <div class="slds-checkbox">
            <input (click)="onInputCreateMissing($event)"
                   id="re-create-missing" name="options"
                   type="checkbox"/>
            <label class="slds-checkbox__label" for="re-create-missing">
              <span class="slds-checkbox_faux"></span>
              <span class="slds-form-element__label">Create missing Links</span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="slds-form__item" role="listitem">
      <div class="slds-form-element">
        <div class="slds-form-element__control">
          <div class="slds-checkbox">
            <input (click)="onInputReSequence($event)"
                   id="re-reorder" name="options"
                   type="checkbox"/>
            <label class="slds-checkbox__label" for="re-reorder">
              <span class="slds-checkbox_faux"></span>
              <span class="slds-form-element__label">Re-sequence WBS</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <article class="">
    <table class="slds-table slds-m-top_medium">
      <thead>
      <tr class="slds-line-height_reset">
        <th scope="col">
          <div class="slds-truncate" i18n title="Work Breakdown Structure">WBS</div>
        </th>
        <th scope="col">
          <div class="slds-truncate" i18n title="Project Line Name">Name</div>
        </th>
        <th class="pr-tight" scope="col">
          <div class="slds-truncate" title="Fix Start Date (not rescheduled)">[=]</div>
        </th>
        <th colspan="3" scope="col">
          <div class="slds-truncate slds-text-align_center" i18n title="Planned Start Date">Planned Start</div>
        </th>
        <th colspan="3" scope="col">
          <div class="slds-truncate slds-text-align_center" i18n title="Planned Effort">Planned Effort</div>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let form of formList; let i = index"
          [attr.data-index]="i"
          [formGroup]="form"
          class="slds-hint-parent">
        <td class="pr-tight">
          <div class="slds-form-element" title="Project Line Work Breakdown Structure">
            <div class="slds-form-element__control" style="max-width: 5rem;">
              <input class="slds-input" formControlName="wbs" name="wbs" type="text"/>
            </div>
          </div>
        </td>
        <td>
          <div class="slds-form-element" title="Project Line Name">
            <div class="slds-form-element__control">
              <input class="slds-input" formControlName="name" name="name" readonly type="text"/>
            </div>
          </div>
        </td>

        <td class="pr-tight">
          <div class="slds-form-element">
            <input formControlName="fix" name="fix" title="Fix Start Date (not rescheduled)" type="checkbox"/>
          </div>
        </td>
        <td class="pr-tight">
          <button (click)="onClickEarlier($event, form)"
                  class="slds-button slds-button_icon slds-button_icon-container"
                  name="earlier"
                  title="Earlier - 1d | 1w" type="button">
            <svg aria-hidden="true" class="slds-button__icon">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#left"></use>
            </svg>
          </button>
        </td>
        <td class="pr-tight">
          <acc-date-element [formGroup]="form" [theId]="'ps-plan-start_' + i"
                            class="slds-form-element slds-dropdown-trigger"
                            controlName="plannedStart"
                            theTitle="Planned Start"></acc-date-element>
        </td>
        <td class="pr-tight">
          <button (click)="onClickLater($event, form)"
                  class="slds-button slds-button_icon slds-button_icon-container" name="later"
                  title="Later - 1d | 1w" type="button">
            <svg aria-hidden="true" class="slds-button__icon">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#right"></use>
            </svg>
          </button>
        </td>

        <td class="pr-tight">
          <button (click)="onClickShorter($event, form)"
                  class="slds-button slds-button_icon slds-button_icon-container" name="shorter"
                  title="Shorter - 8h/1d | 40h/1w" type="button">
            <svg aria-hidden="true" class="slds-button__icon">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#arrowdown"></use>
            </svg>
          </button>
        </td>
        <td class="pr-tight">
          <div class="slds-form-element" title="Planned Effort">
            <div class="slds-form-element__control">
              <input class="slds-input" formControlName="plannedEffort" name="plannedEffort"/>
            </div>
          </div>
        </td>
        <td class="pr-tight">
          <button (click)="onClickLonger($event, form)"
                  class="slds-button slds-button_icon slds-button_icon-container" name="longer"
                  title="Longer - 8h/1d | 40h/1w" type="button">
            <svg aria-hidden="true" class="slds-button__icon">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#arrowup"></use>
            </svg>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </article>

  <hr/>
  <div>
    <button (click)="onReschedule()"
            class="slds-button slds-button_neutral"
            id="re-reschedule">
      <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
        <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#macros"></use>
      </svg>
      <span i18n>Reschedule</span>
    </button>
    <span class="slds-m-horizontal_small slds-text-color_error"
          id="re-error">{{error}}</span>
    <span class="slds-m-horizontal_small"
          id="re-message">{{message}}</span>
  </div>

  <div class="slds-m-vertical_large">
    x
  </div>

  <div style="display: block">
    <hr/>
    <div *ngFor="let form of formList; let i = index">
      <small>{{form.value | json}}</small>
    </div>
  </div>

</section>

